export default __webpack_public_path__ + "static/media/ssc-hxln-shengli.9a6a2fde.png";